/* eslint-disable linebreak-style */
// eslint-disable-next-line linebreak-style
/* eslint-disable max-len */
/* eslint-disable linebreak-style */
/* eslint-disable react/prop-types */
import React from 'react';
import { Typography, Paper, Button, ListItem, ListItemText, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import CheckIcon from '@material-ui/icons/Check';
import { ExpandMore } from '@material-ui/icons';
import CardPremium from '../../../assets/images/cardPremium.jpg';

class PremiumCard extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <Grid>
        <Paper elevation={2} style={{ flexBasis: '40%', margin: 'auto', marginTop: 'initial' }} className={classes.paperGraphics} data-tut="reactour__Faltantes">
          <Typography
            variant="h6"
            component="h4"
            color="textSecondary"
            align="left"
            style={{ padding: 20, fontColor: '#8898AA', fontSize: 15 }}
          >
            {' Plano Premium '}
          </Typography>

          <div
            style={{
              height: 300,
              minWidth: 300,
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img style={{ maxWidth: '250px', opacity: '0.8' }} src={CardPremium} alt="Imagem Plano Premium" />
              <Typography variant="h2" style={{ margin: '-0.25em 0', fontSize: '1.2rem', fontWeight: 'bold', textAlign: 'center', }}>
                Apenas R$ 89,90
                <Typography inline variant="h5" component="span" style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>/mês</Typography>
              </Typography>
              <Button style={{ width: '40%', margin: '15px' }} variant="contained" color="primary" href='https://app.puntu.digital/login/assinatura'>Comprar</Button>
            </div>
          </div >
        </Paper>
        <ExpansionPanel style={{ marginTop: 0 }} >
          <ExpansionPanelSummary expandIcon={<ExpandMore />} IconButtonProps={{ style: { position: 'absolute', right: '14px' } }}>
            <Typography className={classes.heading}> Ver Detalhes </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails style={{ paddingLeft: '15px' }}>
            <div>
              <ListItem style={{ padding: '1px' }}>
                <CheckIcon style={{ color: '#40c78d', marginTop: '5px', marginBottom: '5px', marginRight: '5px', fontSize: '20px' }} />
                <ListItemText style={{ fontSize: '15px' }} primary="Funcionalidades Premium" />
              </ListItem>
              <ListItem style={{ padding: '1px' }}>
                <CheckIcon style={{ color: '#40c78d', padding: '1px', marginTop: '5px', marginBottom: '5px', marginRight: '5px', fontSize: '20px' }} />
                <ListItemText style={{ fontSize: '15px' }} primary="Suporte Premium via Chat" />
              </ListItem>
              <ListItem style={{ padding: '1px' }}>
                <CheckIcon style={{ color: '#40c78d', padding: '1px', marginTop: '5px', marginBottom: '5px', marginRight: '5px', fontSize: '20px' }} />
                <ListItemText style={{ fontSize: '15px' }} primary="Suporte via vídeo chamada (1x por mês)" />
              </ListItem>
              <ListItem style={{ padding: '1px' }}>
                <CheckIcon style={{ color: '#40c78d', padding: '1px', marginTop: '5px', marginBottom: '5px', marginRight: '5px', fontSize: '20px' }} />
                <ListItemText style={{ fontSize: '15px' }} primary="Sem limites de funcionários" />
              </ListItem>
              <ListItem style={{ padding: '1px' }}>
                <CheckIcon style={{ color: '#40c78d', padding: '1px', marginTop: '5px', marginBottom: '5px', marginRight: '5px', fontSize: '20px' }} />
                <ListItemText style={{ fontSize: '15px' }} primary="Desconto no plano Multiempresa" />
              </ListItem>
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </Grid >
    );
  }
}
export default PremiumCard;
